export const sorghoPrecocities = ['tresprecoce', 'precoce', 'mitardif'];
export const seedCornSizes = ['petit', 'moyen', 'grand'];
export const possibleCIPANDevelopment = [1, 2, 3];
const wbArvalisSoilRegions = [
    'Alsace',
    'Aquitaine',
    'Auvergne',
    'Basse Normandie',
    'Bourgogne',
    'Bretagne',
    'Centre-Val-de-Loire',
    'Champagne-Ardenne',
    'Franche-Comté',
    'Haute-Normandie',
    'Ile-de-France',
    'Limousin',
    'Lorraine',
    'Languedoc-Roussillon',
    'Midi-Pyrénées',
    'Nord-Pas-de-Calais',
    'Poitou-Charentes',
    'Picardie',
    'Pays-de-la-Loire',
    "Provence-Alpes-Côte-d'Azur",
    'Rhône-Alpes'
];
export const wbArvalisSoilTexture = [
    'Argileux (>30% A ou >25% A et >55%S)',
    'Limon-argileux (<55% S et 18%<A<35%)',
    'Limoneux (<55% S et <18% A)',
    'Limono-sableux (15%<S<55% et <18% A)',
    'Sableux (>55% S et <15% A)',
    'Sablo-limoneux (>55% S et <25% A)'
];
export const cornTypes = ['MAIS_GRAIN', 'MAIS_FOURRAGE', 'MAIS_SEMENCE', 'MAIS_DOUX'];
export const nonCornTypes = [
    'BT',
    'BD',
    'SOJA',
    'SORGHO',
    'PDT',
    'HARICOT'
    // 'EPINARD',
];
/**
 * List validated on the 31/03/22 email by pierre from the 03/03/22
 */
export const arvalisCropTypes = [...cornTypes, ...nonCornTypes];
export const isSorgho = (cropType) => {
    return cropType === 'SORGHO';
};
export const isGreenBean = (cropType) => {
    return cropType === 'HARICOT';
};
export const isSweetCorn = (cropType) => {
    return cropType === 'MAIS_DOUX';
};
export const isSeedCorn = (cropType) => {
    return cropType === 'MAIS_SEMENCE';
};
export const isCorn = (cropType) => {
    return cornTypes.includes(cropType);
};
export const isWheat = (cropType) => {
    return ['BT', 'BD'].includes(cropType);
};
export const isRawSorghoCharacteristics = (characteristics) => {
    return 'precocite' in characteristics;
};
export const isRawSweetCornCharacteristics = (characteristics) => {
    return 'supersweet' in characteristics;
};
export const isRawSeedCornCharacteristics = (characteristics) => {
    return 'gabarit' in characteristics;
};
export const allCropCharacteristicsKeys = [
    'femaleGenitor',
    'gddBtwSowingFlowering',
    'm1SowingDate',
    'm2SowingDate',
    'm3SowingDate',
    'maleGenitor',
    'numberOfDaysBtwSowingFlowering',
    'precocity',
    'size',
    'sowingDevice',
    'supersweet',
    'variety'
];
export const isSorghoCharacteristics = (characteristics) => {
    return 'precocity' in characteristics;
};
export const isSweetCornCharacteristics = (characteristics) => {
    return 'supersweet' in characteristics;
};
export const isSeedCornCharacteristics = (characteristics) => {
    return 'size' in characteristics;
};
export const wbArvalisDepth = [
    'Superficiel (arrêt tarière <40 cm)',
    'Moyen (40cm <arrêt tarière< 80 cm)',
    'Profond (arrêt tarière >80 cm)'
];
export const wbArvalisLimestone = ['Calcaire (>5%)', 'Non calcaire (0 à 5%)'];
export const wbArvalisHydromorphy = ['Hydromorphe (<60cm)', 'Non hydromorphe'];
export const wbArvalisStoniness = [
    'Non caillouteux (<5%)',
    'Peu caillouteux (5-15%)',
    'Caillouteux (>15%)'
];
export const FARMER_PREFIX = 'farmer_';
export const TECH_RPEFIX = 'tech_';
export const CLIENT_PREFIX = 'client_';
export const PLOT_PREFIX = 'plot_';
export const GREEN_BEAN_APRIL_SOWING_DEPT = [
    9, 11, 12, 24, 30, 31, 32, 33, 34, 40, 46, 47, 48, 64, 65, 66, 81, 82
];
export const GREEN_BEAN_MAY_SOWING_DEPT = [2, 59, 60, 62, 80, 22, 29, 35, 56];
export const GREEN_BEAN_AUTHORIZED_DEPARTMENTS = [
    ...GREEN_BEAN_APRIL_SOWING_DEPT,
    ...GREEN_BEAN_MAY_SOWING_DEPT
].sort((a, b) => a - b);
